import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Lock, ArrowRight } from "lucide-react";
import { adminLogin } from "../../lib/adminApi";
import BenoLogo from "../../components/BenoLogo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await adminLogin(email, password);
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 grain" data-testid="admin-login-page">
      <motion.form
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="w-full max-w-md bg-[#15171A] border border-white/8 p-8 md:p-10 relative"
      >
        <Link to="/" className="text-xs uppercase tracking-[0.3em] text-white/40 hover:text-[#C17F59] transition-colors">← Public Atlas</Link>
        <div className="mt-8 mb-4 flex justify-center">
          <BenoLogo size={96} />
        </div>
        <p className="overline text-[#C17F59] text-center mb-2">Liquid Control Room</p>
        <h1 className="font-display text-4xl tracking-tight leading-tight mb-2 text-center">Sign in.</h1>
        <p className="font-hand text-xl text-[#D89A74] -rotate-1 mb-8 text-center">— back of house only.</p>

        <label className="block mb-5">
          <span className="overline text-white/50 mb-2 block">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                 className="w-full bg-transparent border-b border-white/15 focus:border-[#C17F59] py-3 text-base focus:outline-none transition-colors"
                 data-testid="admin-login-email" autoComplete="email" />
        </label>
        <label className="block mb-7">
          <span className="overline text-white/50 mb-2 block">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                 className="w-full bg-transparent border-b border-white/15 focus:border-[#C17F59] py-3 text-base focus:outline-none transition-colors"
                 data-testid="admin-login-password" autoComplete="current-password" />
        </label>

        {error && <p className="text-sm text-red-400 mb-4" data-testid="admin-login-error">{error}</p>}

        <button type="submit" disabled={loading}
                className="w-full inline-flex items-center justify-center gap-3 bg-[#C17F59] text-[#0E0F0C] px-6 py-4 text-xs uppercase tracking-[0.3em] hover:bg-[#D89A74] transition-colors disabled:opacity-60"
                data-testid="admin-login-submit">
          <Lock size={14} />
          {loading ? "Signing in..." : "Enter Control Room"}
          <ArrowRight size={14} />
        </button>
      </motion.form>
    </div>
  );
}
